export default "__VITE_ASSET__NqX5fOAe__"